// Priorité d'un point (question, écart, contrôle, exclusion) POUR LE DESTINATAIRE du courrier — partagée par le serveur et l'interface.
// « Bloquant » : à obtenir avant de signer un devis ou de chiffrer (sécurité, périmètre du prix, pièces manquantes, devis périmé,
// doublons chiffrés, appareils sans puissance). « Important » : à faire préciser. « Complément » : utile, non indispensable —
// proposé DÉCOCHÉ dans un nouveau courrier (toujours cochable).

export const PRIORITES = ['bloquant', 'important', 'complement'] as const;
export type Priorite = typeof PRIORITES[number];

export const PRIORITES_INFO: Record<Priorite, { libelle: string; aide: string }> = {
  bloquant: { libelle: 'Bloquant', aide: 'À obtenir avant de signer ou de chiffrer' },
  important: { libelle: 'Important', aide: 'À faire préciser' },
  complement: { libelle: 'Complément', aide: 'Utile, non indispensable : décoché par défaut dans un nouveau courrier' },
};

/** Rang de tri : bloquant d'abord. Une priorité absente (point préparé avant les priorités) compte comme « important ». */
export const rangPriorite = (p: string | null | undefined) => (p === 'bloquant' ? 0 : p === 'complement' ? 2 : 1);
